import React from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';

import Header from './layout/Header';

import Page404 from './pages/Page404';
import SignUp from './pages/SignUp';
import SignIn from './pages/SignIn';
import PasswordForgot from './pages/ForgotPassword';

import 'normalize.css';
import './auth.scss';
import Pick from '../App/apps/Pick';

export default () => {
  return (
    <Router>
      <div className="auth">
        <Header />
        <div className="aligner">
          <Switch>
            <Route path="/signup" component={SignUp} />
            <Route path="/signin" component={SignIn} />
            <Route path="/forgot-password" component={PasswordForgot} />
            <Route path="/s/:strategyId/p/:pickId" component={Pick} />
            <Route path="*" component={Page404} />
          </Switch>
        </div>
      </div>
    </Router>
  );
};
